module.exports = __webpack_public_path__ + "img/12217_6.b97776bc.png";